import { Theme, ThemeOptions, createTheme as createMuiTheme } from '@mui/material';
import { defaultThemeOptions } from './theme';

const getRawThemeSpacing = (theme: Theme, spacing: number): number => Number(theme.spacing(spacing).slice(0, -2));

const withRawSpacing = (theme: Theme): Theme =>
  Object.assign(theme, { rawSpacing: (spacing: number) => getRawThemeSpacing(theme, spacing) });

export const createTheme = (options: ThemeOptions): Theme =>
  withRawSpacing(createMuiTheme({ ...defaultThemeOptions, ...options }));
